import { isCateringDisposition, isPickupDisposition } from 'common/utilities/utils';
import React, { useEffect } from 'react';
import { accordionPanelView, staticPanelView } from '../sharedTemplates/orderSummaryInfoDetailsTemplates';

const OrderSummaryInfoDetailsView = props => {
  const { orderDetails, updateSetOrderDetails } = props;
  const { service, orderSummaryInfoDetailsShowInAccordion } = orderDetails;

  useEffect(() => {
    updateSetOrderDetails({
      showStoreDirectinPanelInOrderSummaryInfoDetails: isPickupDisposition(service) || isCateringDisposition(service),
      showStoreHoursPanelInOrderSummaryInfoDetails: true,
      showCombinedDiscount: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return orderSummaryInfoDetailsShowInAccordion ? accordionPanelView(props) : staticPanelView(props);
};

export default React.memo(OrderSummaryInfoDetailsView);
